import { Fragment } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PPRouterProps } from '../../../routes/paths';
import { configs } from './MagicBoxConfigs';
import { MAGIC_BOX_COMPONENTS } from './MAGIC_BOX_COMPONENTS';
import { changePathAndFocus } from './magicBoxUtils';

const VisitsEmpty: React.FC = () => {
    const history = useHistory();
    const params: PPRouterProps = useParams();
    const { pxId, pxState } = params;

    const handleCta = () => {
        changePathAndFocus(
            configs[MAGIC_BOX_COMPONENTS.VISITS].elId,
            history,
            pxId,
            pxState,
            'patient-overview',
        );
    };
    return (
        <Fragment>
            <p className="text-13 w-168 m-auto text-center mt-48 mb-32 text-darwin-neutral-800 font-400">
                You can see your patient's{' '}
                <span
                    onClick={handleCta}
                    className="font-700 text-darwin-accent-green-900 cursor-pointer hover:underline hover:underline-darwin-accent-green-900"
                >
                    past visits
                </span>{' '}
                here
            </p>
            <div className="mx-22 mb-13 p-10 px-12 border border-darwin-accent-green-200 bg-darwin-accent-green-100 text-13 font-400 rounded-4 text-darwin-accent-green-900">
                <p className="font-700 mb-8">14 March'22</p>
                <div className="flex-col space-y-5">
                    <p>Symptoms</p>
                    <p className="h-7 w-92 bg-darwin-accent-green-200 rounded-full"></p>
                    <p>Diagnosis</p>
                    <p className="h-7 w-92 bg-darwin-accent-green-200 rounded-full"></p>
                    <p>Medicines</p>
                    <p className="h-7 w-92 bg-darwin-accent-green-200 rounded-full"></p>
                </div>
            </div>
            <div className="mx-22 mb-13 p-10 px-12 border border-darwin-accent-green-200 bg-darwin-accent-green-100 text-13 font-400 rounded-4 text-darwin-accent-green-900">
                <p className="font-700 mb-8">26 March'22</p>
                <div className="flex-col space-y-5">
                    <p>Symptoms</p>
                    <p className="h-7 w-92 bg-darwin-accent-green-200 rounded-full"></p>
                    <p>Diagnosis</p>
                    <p className="h-7 w-92 bg-darwin-accent-green-200 rounded-full"></p>
                    <p>Medicines</p>
                    <p className="h-7 w-92 bg-darwin-accent-green-200 rounded-full"></p>
                </div>
            </div>
        </Fragment>
    );
};

export default VisitsEmpty;
